<template>
  <a-drawer
    title="权限设置"
    placement="right"
    :closable="false"
    @close="onClose"
    :visible="visible"
    width="360"
  >
    <div v-if="loading" style="text-align: center"><a-spin/></div>
    <div v-if="!loading">
      <!-- <a-input-search style="margin-bottom: 8px" placeholder="请输入你要搜索的权限名称" @pressEnter="onChange" /> -->
      <a-tree
        checkable
        showIcon
        @check="onCheck"
        @expand="onExpand"
        :expandedKeys="expandedKeys"
        :autoExpandParent="autoExpandParent"
        v-model="checkedKeys"
        :treeData="addRoleTreeData"
      >
        <!-- <div slot="number">{{ }}</div> -->
      </a-tree>
      <!-- 底部按钮 -->
      <div class="footerStyle">
        <a-button type="primary" style="margin:5px 10px 5px 0px" @click="savePermission">保存</a-button>
        <a-button type="dashed" style="margin:5px 10px 5px 0px" @click="onClose">取消</a-button>
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { replaceTreeKey } from '@/utils/util'
import { getAuthData, postAddRolePermission } from '@/api/role'
import _ from 'lodash'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: Number,
      default: 0
    },
    defalutPermissionArr: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      addRoleTreeData: [],
      // 抽屉加载
      loading: true,
      // 用户权限数据
      permissionData: {
        permissionIds: '',
        roleId: ''
      }
    }
  },
  methods: {
    // 输入框事件
    onChange (e) {
      console.log(e.target.value)
    },
    // 展开节点事件
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // 多选框选择事件
    onCheck (checkedKeys) {
      this.checkedKeys = checkedKeys
    },
    // 保存按钮事件
    savePermission () {
      this.permissionData.roleId = this.roleId
      if (this.checkedKeys.length > 0) {
        this.permissionData.permissionIds = this.checkedKeys.join(',')
      }
      postAddRolePermission(this.permissionData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('权限设置完成')
          this.$emit('finish')
        }
      })
    },
    // 加载添加用户权限数据
    handleGetAuthData () {
      this.loading = true
      getAuthData().then(res => {
        if (_.get(res, 'code') === 200) {
          this.addRoleData = _.get(res, 'data', [])
          this.addRoleTreeData = replaceTreeKey(this.addRoleData, {
            key: 'auth_id',
            title: 'auth_name',
            children: 'childData'
          })
          _.forEach(this.addRoleTreeData, obj => {
            obj.slots = {
              icon: 'number'
            }
          })
          this.checkedKeys = this.defalutPermissionArr
          setTimeout(() => { this.loading = false }, '1000')
        }
      })
    },
    // 关闭权限设置抽屉
    onClose () {
      this.$emit('hide')
    }
  },
  created () {
    this.handleGetAuthData()
  }
}

</script>
<style lang="less" scoped>
.footerStyle {
    position:absolute;
    bottom:0px;
    right:0px;
    width:100%;
    height:60px;
    padding:10px 20px;
    text-align:center;
  }
</style>
